import { emotionColors } from '@/theme/affexyTokens'
import type { ParticipationStatus } from '@/services/respondentBaseService'

/** Brand-consistent hues for avatars and group dots, picked by a stable id. */
const PALETTE = [
  emotionColors.sadness,
  emotionColors.disgust,
  emotionColors.attention,
  emotionColors.surprise,
  emotionColors.joy,
  emotionColors.anger,
]

export function hueFor(id: number): string {
  return PALETTE[Math.abs(id) % PALETTE.length]
}

/** Two initials from the name, else the first letter of the address. */
export function initialsFor(name: string, email: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean)
  if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase()
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase()
  return email.slice(0, 1).toUpperCase()
}

export function statusColor(status: ParticipationStatus): string {
  switch (status) {
    case 'completed':
      return '#2E9E6A'
    case 'in_progress':
      return emotionColors.sadness
    case 'cancelled':
      return 'rgba(27,28,56,.32)'
    default:
      return emotionColors.surprise
  }
}

/** Loose on purpose: the backend runs Django's validator, this only flags obvious typos. */
const EMAIL_RE = /^[^\s@<>,;]+@[^\s@<>,;]+\.[^\s@<>,;]{2,}$/

export function isEmail(value: string): boolean {
  return EMAIL_RE.test(value)
}

/** Split pasted text the way the bulk endpoint does, and pull addresses out of `Name <a@b.pl>`. */
export function splitAddresses(raw: string): string[] {
  const parts = raw
    .split(/[\s,;]+/)
    .map((part) => part.replace(/^[<"']+|[>"']+$/g, '').trim().toLowerCase())
    .filter(Boolean)
  // A pasted "Jan Kowalski <jan@x.pl>" or a spreadsheet row carries words that
  // are not addresses; once any part has an @, the rest are names, not typos.
  return parts.some((part) => part.includes('@')) ? parts.filter((part) => part.includes('@')) : parts
}
